import { useOutletContext } from 'react-router-dom'

function Embed(){
	const { translate } = useOutletContext()
	return <h1>{translate('embed-header')}</h1>
}

export default Embed